import _     from 'underscore';
import React from 'react';

import { CorvalCategory, CorvalProjectBudgetItem, CorvalStaticProjectBudgetItem, CorvalSubCategory } from '../types';

export interface ExtendedCorvalProjectBudgetItem extends CorvalProjectBudgetItem, CorvalStaticProjectBudgetItem {
	category?: CorvalCategory,
	subCategory?: { id: string } & Pick<CorvalSubCategory, 'name' | 'displayName'>,
}

export interface UseProjectBudgetItemsHook {

	getIdForItemGroup( budgetItems: CorvalProjectBudgetItem | CorvalStaticProjectBudgetItem ): string

	injectCategoryInformation( budgetItems: CorvalProjectBudgetItem[] | CorvalStaticProjectBudgetItem[], categories: Partial<CorvalCategory>[] ): ExtendedCorvalProjectBudgetItem[],

	getCustomBudgetItemTags( item: Partial<CorvalProjectBudgetItem | CorvalStaticProjectBudgetItem> ): string[],
}

export function useProjectBudgetItems(){

	const getIdForItemGroup: UseProjectBudgetItemsHook['getIdForItemGroup'] = ( budgetItem ) => {

		return `${ budgetItem.categoryId }-${ budgetItem.subCategoryName.split( ' ' ).join( '-' ) }`
	}

	const injectCategoryInformation: UseProjectBudgetItemsHook['injectCategoryInformation'] = ( budgetItems, categories ) => {

		return budgetItems.map( ( item ) => {

			// synthesize subcategory / category info for info and structuralization
			let category = _.findWhere( categories, { id: item.categoryId } );

			return ( {
				...item,
				category,
				subCategory: {
					id:          getIdForItemGroup( item ),
					name:        item.subCategoryName,
					displayName: item.subCategoryName,
				},
			} as ExtendedCorvalProjectBudgetItem )
		} )
	}

	// tags info
	// @TODO: Custom budget item tags are not support just yet, remove ignores once it is.
	const getCustomBudgetItemTags: UseProjectBudgetItemsHook['getCustomBudgetItemTags'] = ( item ) => {

		let tags             = new Set(),
		    extractTagMethod = tagEntity => tags.add( tagEntity.tag.name );

		//@ts-ignore
		if( item.tags && _.isArray( item.tags ) ){

			//@ts-ignore
			item.tags.map( extractTagMethod );

		}

		return Array.from( tags ) as string[];
	}

	return {
		getIdForItemGroup,
		injectCategoryInformation,
		getCustomBudgetItemTags,
	} as UseProjectBudgetItemsHook
}
